const local = "_PROVIDER_AERONAVES_FOLLOWAIR_"

var update = false

export default {

    methods: {

        _GET_AERONAVE: function(callback){
            this._httpGet('/Aeronave/get', function(retorno){
                if(retorno._request && retorno._status){
                    callback(retorno.lista.length > 0 ? retorno.lista : null)
                } else {
                    callback(null)
                }
            })
        },

        _providerAeronaveUpdate: function(load){

            if(load){
                bus.$emit('load-in', {text: 'Atualizado cache'})
            }

            this._GET_AERONAVE(function(lista){
                if(load){
                    bus.$emit('load-out')
                }

                if(lista != null){
                    var string = JSON.stringify(lista);
                    sessionStorage.setItem(local, string);
                }
            })
        },

        _providerAeronave: function(callback){

            //console.log("update aeronave", update)

            if(!update){
                update = true
                this._GET_AERONAVE(function(lista){
                    if(lista != null){
                        var string = JSON.stringify(lista);
                        sessionStorage.setItem(local, string);
                        callback(lista)
                    } else {
                        callback([])
                    }
                })
            }
    
            // se existir config do cliente	
            if(sessionStorage.getItem(local) != null){
                callback(JSON.parse(sessionStorage.getItem(local)))
            } else {

                this._GET_AERONAVE(function(lista){
                    if(lista != null){
                        var string = JSON.stringify(lista);
                        sessionStorage.setItem(local, string);
                        callback(lista)
                    } else {
                        callback([])
                    }
                })
            }
        }
    }
}